/* eslint-disable import/prefer-default-export */
import axios from "../config/axios";
import { store } from "../../js/store";

export function consultarFormulariosExistentes(documento, nombre_formulario) {
  return new Promise((resolve, reject) => {
    axios
      .post("controlador_datos/historia_clinica/api/v1/formularios_paciente", {
        documento,
        nombre_formulario
      })
      .then(result => {
        resolve(result);
      })
      .catch(err => {
        reject(err);
      });
  });
}
export function actualizarFormulariosExistentes(docId, key, variables) {
  return new Promise((resolve, reject) => {
    axios
      .post("/formularios_cuestionarios/formularios/api/v2/actualizar", {
        docId,
        variables,
        key: "resumen_de_llamada"
      })
      .then(result => {
        // store.dispatch('setCargando', false);
        resolve(result);
      })
      .catch(err => {
        reject(err);
      });
  });
}
export function consultarInformacionTarjetaEspecifica(formulario_id) {
  return new Promise((resolve, reject) => {
    axios
      .get("controlador_datos/formularios/api/v1/leerFormlularioPorId", {
        params: {
          formulario_id
        }
      })
      .then(result => {
        resolve(result);
      })
      .catch(err => {
        reject(err);
      });
  });
}
export async function eliminarFormulariosExistentes(docId, key) {
  return await axios
    .delete("/formularios_cuestionarios/formularios/api/v3/eliminar", {
      data: { docId, key }
    })
    .then(result => {
      if (result && result.response && result.response.status === 400) {
        return result.response;
      }
      return result;
    })
    .catch(err => err.response);
}
export async function crearFormulario(
  coleccion,
  tipo_esquema,
  creado_por,
  momento,
  documento,
  origen,
  id
) {
  return await axios
    .post(`/formularios_cuestionarios/${coleccion}/api/v3/crear`, {
      tipo_esquema,
      creado_por,
      momento,
      documento,
      id,
      origen
    })
    .then(result => result)
    .catch(err => err.response);
}
export function consultarEstructuraFormulariosPorId(formulario_id) {
  return new Promise((resolve, reject) => {
    axios
      .get("/controlador_datos/formularios/api/v1/esquemaFormlularioPorId", {
        params: {
          formulario_id
        }
      })
      .then(result => {
        resolve(result);
      })
      .catch(err => {
        reject(err);
      });
  });
}
export function actualizarFormulario(
  docId,
  key,
  variables,
  collection,
  creado_por
) {
  return new Promise((resolve, reject) => {
    axios
      .put(`/formularios_cuestionarios/${collection}/api/v3/actualizar`, {
        docId,
        key,
        variables,
        creado_por
      })
      .then(result => {
        // store.dispatch('setCargando', false);
        resolve(result);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export async function consultarInformacionGeneralPaciente(
  documento,
  tipo_esquema
) {
  return await axios.post(
    "/formularios_cuestionarios/formularios/api/v3/leer_resumen",
    {
      documento,
      tipo_esquema
    }
  );
}
/**
 * Copia para consultar datos desde HC
 * @param {Number} documento 
 * @param {String} tipo_esquema 
 * @returns 
 */
export async function consultarInformacionGeneralPacienteV2(
  documento,
  tipo_esquema
) {
  return await axios.post(
    "/formularios_cuestionarios/formularios/api/v3/leer_resumen",
    {
      documento,
      tipo_esquema
    }
  );
}
export async function consultarFormularioLLenopacienteTerapia(
  tipo_esquema,
  docId
) {
  return await axios.get("/formularios_cuestionarios/formularios/api/v3/leer", {
    params: {
      tipo_esquema,
      docId
    }
  });
}



// WEBPACK FOOTER //
// ./src/apiService/request/CrudFormulario.js